import { memoize } from '@exodus/basic-utils';
function processValue(value, seen) {
    if (value === null || value === undefined) {
        return value;
    }
    if (typeof value !== 'object') {
        const isSpecialType = ['symbol', 'function', 'bigint'].includes(typeof value);
        return isSpecialType ? value.toString() : value;
    }
    if (seen.has(value)) {
        return '[Circular]';
    }
    seen.add(value);
    if (isModelWithToJSON(value)) {
        return value.toJSON();
    }
    if (value instanceof RegExp) {
        return value.toString();
    }
    if (value instanceof Date) {
        return value.toISOString();
    }
    if (value instanceof Map) {
        return [...value.entries()].map(([k, v]) => [k, processValue(v, seen)]);
    }
    if (value instanceof Set) {
        return [...value].map((v) => processValue(v, seen));
    }
    if (Array.isArray(value)) {
        return value.map((v) => processValue(v, seen));
    }
    const result = {};
    for (const [key, val] of Object.entries(value)) {
        if (val !== undefined) {
            result[key] = processValue(val, seen);
        }
    }
    return result;
}
function safeSerialize(value) {
    try {
        return JSON.stringify(processValue(value, new WeakSet()));
    }
    catch {
        console.error('Could not serialize value:', value);
        throw new Error('Value could not be serialized for memoization');
    }
}
function isModelWithToJSON(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'toJSON' in value &&
        typeof value.toJSON === 'function');
}
export function safeMemoize(fn) {
    return memoize(fn, safeSerialize);
}
